import axios from "axios";

export function getVideos(s: string = '', page: number = 1, per_page: number = 12, tags?: number[]) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/video';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (tags && tags.length > 0) {
        params.push('tag=' + tags.join(','));
    }
    params.push('page=' + page);
    params.push('per_page=' + per_page);
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getVideoSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/video/' + id;
    return axios.get(endpointUrl, { headers: headers } );
}

export function createVideo(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/video';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateVideo(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/video';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteVideo(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/video/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

// Video Tags

export function getVideoTags() {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/video-tag';
    return axios.get(endpointUrl, { headers: headers });
}

export function createVideoTag(name: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/video-tag';
    return axios.post(endpointUrl, JSON.stringify({ name }), { headers: headers });
}

export function updateVideoTag(id: number, name: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/video-tag';
    return axios.patch(endpointUrl, JSON.stringify({ id, name }), { headers: headers });
}

export function deleteVideoTag(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/video-tag/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}
